var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"back-to-top page-scroll",attrs:{"href":"#header"}},[_vm._v("Back to Top")])
}
var staticRenderFns = []

export { render, staticRenderFns }